// extracted by mini-css-extract-plugin
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--181aa";
export var pageBody = "detailsPage-module--page-body--810c9";
export var pageFooter = "detailsPage-module--page-footer--33315";
export var pageFooterBack = "detailsPage-module--page-footer-back--c27e4";
export var pageIntro = "detailsPage-module--page-intro--2c25b";
export var pageIntroContainer = "detailsPage-module--page-intro-container--b8f40";
export var pageIntroImg = "detailsPage-module--page-intro-img--c9b32";
export var pageIntroImgFull = "detailsPage-module--page-intro-img-full--ac160";
export var pageIntroTaxoContainer = "detailsPage-module--page-intro-taxo-container--64fd0";
export var pageIntroTitle = "detailsPage-module--page-intro-title--d70f5";
export var pageTaxo = "detailsPage-module--page-taxo--bf946";